var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaragLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 690 290",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "MetaRAG logo") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "MetaRAG - Intelligent Pipeline Selection Engine logo with geometric prism and node network design"), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1L8 5L2 9",
    fill: "none",
    stroke: "context-stroke",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 280,
    fill: "#0a0f1e",
    rx: 16,
    style: {
      fill: "rgb(10, 15, 30)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 140,
    r: 90,
    style: {
      fill: "none",
      stroke: "rgb(79, 142, 247)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 140,
    r: 70,
    style: {
      fill: "none",
      stroke: "rgb(79, 142, 247)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.25,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120,68 68,158 120,140",
    style: {
      fill: "rgb(26, 26, 46)",
      stroke: "rgb(79, 142, 247)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120,68 172,158 120,140",
    style: {
      fill: "rgb(22, 33, 62)",
      stroke: "rgb(79, 142, 247)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68,158 172,158 120,140",
    style: {
      fill: "rgb(15, 52, 96)",
      stroke: "rgb(79, 142, 247)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 68,
    r: 4,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 158,
    x2: 230,
    y2: 108,
    style: {
      fill: "none",
      stroke: "rgb(79, 142, 247)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 158,
    x2: 230,
    y2: 145,
    style: {
      fill: "none",
      stroke: "rgb(45, 212, 191)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 158,
    x2: 230,
    y2: 175,
    style: {
      fill: "none",
      stroke: "rgb(167, 139, 250)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 158,
    x2: 230,
    y2: 208,
    style: {
      fill: "none",
      stroke: "rgb(251, 191, 36)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 108,
    r: 5,
    style: {
      fill: "rgb(79, 142, 247)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 145,
    r: 5,
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 175,
    r: 5,
    style: {
      fill: "rgb(167, 139, 250)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 208,
    r: 5,
    style: {
      fill: "rgb(251, 191, 36)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 108,
    x2: 270,
    y2: 120,
    style: {
      fill: "none",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.75px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 145,
    x2: 270,
    y2: 120,
    style: {
      fill: "none",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.75px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 175,
    x2: 270,
    y2: 185,
    style: {
      fill: "none",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.75px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 208,
    x2: 270,
    y2: 185,
    style: {
      fill: "none",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.75px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 120,
    r: 4,
    style: {
      fill: "#4f8ef7",
      opacity: 0.6,
      fill: "rgb(79, 142, 247)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 185,
    r: 4,
    style: {
      fill: "#a78bfa",
      opacity: 0.6,
      fill: "rgb(167, 139, 250)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 100,
    x2: 68,
    y2: 130,
    style: {
      stroke: "#1e3a5f",
      strokeWidth: 0.5,
      fill: "none",
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 170,
    x2: 68,
    y2: 155,
    style: {
      stroke: "#1e3a5f",
      strokeWidth: 0.5,
      fill: "none",
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 140,
    x2: 68,
    y2: 148,
    style: {
      stroke: "#1e3a5f",
      strokeWidth: 0.5,
      fill: "none",
      fill: "none",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 100,
    r: 3,
    style: {
      fill: "#1e3a5f",
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 140,
    r: 3,
    style: {
      fill: "#1e3a5f",
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 170,
    r: 3,
    style: {
      fill: "#1e3a5f",
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 140,
    x2: 680,
    y2: 140,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 105,
    style: {
      fill: "rgb(241, 245, 249)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 62,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Meta"), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 105,
    style: {
      fill: "rgb(79, 142, 247)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 62,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "RAG"), /*#__PURE__*/React.createElement("text", {
    x: 274.15,
    y: 130,
    style: {
      fill: "rgb(100, 116, 139)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 13,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "INTELLIGENT PIPELINE SELECTION ENGINE"), /*#__PURE__*/React.createElement("line", {
    x1: 332,
    y1: 145,
    x2: 620,
    y2: 145,
    style: {
      stroke: "#1e3a5f",
      strokeWidth: 0.5,
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(30, 58, 95)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 274.15,
    y: 165,
    style: {
      fill: "rgb(148, 163, 184)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "build  \xB7  evaluate  \xB7  compare  \xB7  autoselect"), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 182,
    width: 52,
    height: 18,
    rx: 4,
    style: {
      fill: "#1e3a5f",
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 195,
    style: {
      fill: "#4f8ef7",
      fontFamily: "monospace",
      fontSize: 10,
      letterSpacing: "0.5px",
      fill: "rgb(79, 142, 247)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "v 0.1"), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 182,
    width: 72,
    height: 18,
    rx: 4,
    style: {
      fill: "#0f2418",
      fill: "rgb(15, 36, 24)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 195,
    style: {
      fill: "#2dd4bf",
      fontFamily: "monospace",
      fontSize: 10,
      letterSpacing: "0.5px",
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "100% local"), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 182,
    width: 60,
    height: 18,
    rx: 4,
    style: {
      fill: "#1a1030",
      fill: "rgb(26, 16, 48)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 482,
    y: 195,
    style: {
      fill: "#a78bfa",
      fontFamily: "monospace",
      fontSize: 10,
      letterSpacing: "0.5px",
      fill: "rgb(167, 139, 250)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "open src"), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 80,
    r: 1.5,
    style: {
      fill: "#4f8ef7",
      opacity: 0.4,
      fill: "rgb(79, 142, 247)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 655,
    cy: 95,
    r: 1,
    style: {
      fill: "#2dd4bf",
      opacity: 0.4,
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 65,
    r: 1,
    style: {
      fill: "#a78bfa",
      opacity: 0.4,
      fill: "rgb(167, 139, 250)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 60,
    r: 1.5,
    style: {
      fill: "#fbbf24",
      opacity: 0.3,
      fill: "rgb(251, 191, 36)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 110,
    r: 1,
    style: {
      fill: "#4f8ef7",
      opacity: 0.3,
      fill: "rgb(79, 142, 247)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaragLogo);
export default __webpack_public_path__ + "static/media/metarag_logo.036dfef75e892ed876dc86ffc6d4d6a5.svg";
export { ForwardRef as ReactComponent };